// src/auth/index.js

import router from '../router'
import axios from 'axios'

export default {

  // User object will let us check authentication status
  user: {
    authenticated: false,
    permissions: null
  },

  // has to be a map to be observed by the view
  version: {
    version: null
  },

  // To log out, we just need to remove the token
  logout () {
    localStorage.removeItem('access_token')
    localStorage.removeItem('permissions')
    this.user.authenticated = false
    this.user.permissions = null
    this.version = null

    this.checkAuth()
  },

  getPermissions () {
    if (this.user.permissions) {
      return this.user.permissions
    }

    const permissionsStr = localStorage.getItem('permissions')
    let permissions = []


    if (permissionsStr) {
      permissions = permissionsStr.split(',')
    }

    this.user.permissions = permissions

    return permissions
  },

  hasPermission (perm) {
    // in this case, 'this' is the array of assigned user permissions
    return this.includes(perm)
  },

  // permissions can be omitted or is an ARRAY of strings
  checkAuth (permissions) {
    const jwt = localStorage.getItem('access_token')

    let hasRequiredPermissions = false

    if (permissions && permissions.length > 0) {
      hasRequiredPermissions = permissions.every(this.hasPermission, this.getPermissions())
    } else {
      hasRequiredPermissions = true
    }

    if (jwt && hasRequiredPermissions) {
      this.user.authenticated = true

      axios.defaults.headers.common.Authorization = this.getAuthHeader().Authorization

      if (!this.version.version) {
        axios.get('/api/version').then(response => {
          this.version.version = response.data.version
        })
      }
    } else {
      this.user.authenticated = false

      delete axios.defaults.headers.common.Authorization

      router.push('/login')
    }
  },

  // The object to be passed as a header for authenticated requests
  getAuthHeader () {
    return {
      Authorization: 'Bearer ' + localStorage.getItem('access_token')
    }
  }
}
